import { createSelector } from 'reselect';
import Immutable from 'immutable';
import {
  selectUGCByType,
  selectSingularUGCByUsers,
  selectUGCByBibs,
  selectSingularUGCForCurrentUser
} from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'ratingsTransactions'], Immutable.Map());

export const selectRatings = selectUGCByType('ratings');
export const selectRatingsByUsers = selectSingularUGCByUsers('ratings');
export const selectRatingsByBibs = selectUGCByBibs('ratings');
export const selectCurrentUserRatings = selectSingularUGCForCurrentUser('ratings');
export const selectRatingsTransactions = createSelector([getTransactions], transactions => transactions);

export default {
  selectRatings,
  selectRatingsByUsers,
  selectRatingsByBibs,
  selectCurrentUserRatings,
  selectRatingsTransactions
};
